import React, { useEffect, useState } from 'react';
import LogoFull from '../../assets/logos/LogoFull';

export default function LoadingScreen() {
  const [visible, setVisible] = useState(true);
  const [fading, setFading]   = useState(false);

  useEffect(() => {
    const fade = setTimeout(() => setFading(true), 800);
    const hide = setTimeout(() => setVisible(false), 1200);
    return () => { clearTimeout(fade); clearTimeout(hide); };
  }, []);

  if (!visible) return null;

  return (
    <div className={`fixed inset-0 z-[9000] bg-navy flex flex-col items-center justify-center
      transition-opacity duration-400 ${fading ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}>
      <div className="animate-[fadeUp_0.5s_ease_both]">
        <LogoFull variant="light" height={48} />
      </div>
      <div className="mt-8 flex gap-1.5">
        {[0, 1, 2].map(i => (
          <span
            key={i}
            className="w-1.5 h-1.5 rounded-full bg-teal animate-[bounce_1s_ease_infinite]"
            style={{ animationDelay: `${i * 0.15}s` }}
          />
        ))}
      </div>
    </div>
  );
}
